export const getSliceSubdomain = () => {
  switch (process.env.NEXT_PUBLIC_CHAIN_ID) {
    case "5":
      return "testnet."
    case "8453":
      return ""
    case "84531":
      return "base-testnet."
    default:
      return ""
  }
}
